import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditHomeSection from '../../components/home_sections/FormAddEditHomeSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import { useTranslation } from 'react-i18next';
import { useGetHomeSectionById } from '../../hooks/home_sections/useGetHomeSectionById';
import { Box, CircularProgress, Typography } from '@mui/material';

const EditHomeSection = () => {
    const { id } = useParams();
    const { t, i18n } = useTranslation();
    const isArabic = i18n.language === 'ar';
    const navigate = useNavigate();

    const { homeSection, isLoading, error } = useGetHomeSectionById(id);

    const onSubmitSuccess = () => {
        navigate('/home-sections');
    };

    const links = [
        { label: isArabic ? 'الرئيسية' : 'Home', path: '/' },
        { label: isArabic ? 'أقسام الصفحة الرئيسية' : 'Home Sections', path: '/home-sections' },
        { label: isArabic ? 'تعديل القسم' : 'Edit Section', path: `/home-sections/${id}/edit`, active: true },
    ];

    if (isLoading) {
        return (
            <WrapperSection>
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                    <CircularProgress />
                </Box>
            </WrapperSection>
        );
    }

    if (error) {
        return (
            <WrapperSection>
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                    <Typography color="error">{t("Error loading section")}</Typography>
                </Box>
            </WrapperSection>
        );
    }

    return (
        <WrapperSection>
            <GlobalBreadcrumbs links={links} />
            <FormAddEditHomeSection currentData={homeSection?.data} isEdit={true} onSubmitSuccess={onSubmitSuccess} />
        </WrapperSection>
    );
};

export default EditHomeSection;
